module.exports = __webpack_public_path__ + "media/vuesrc/components/cta/tada-38bb685f16d4421e122362fd62af5a4b.gif";